import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PublicGallery from '@/components/PublicGallery';
import SEO, { createBreadcrumbSchema } from '@/components/SEO';

// ImageGallery schema for rich results
const imageGallerySchema = {
  "@context": "https://schema.org",
  "@type": "ImageGallery",
  "name": "AI Generated Image Gallery",
  "description": "Browse 10,000+ stunning AI-generated images created with FLUX AI. Get prompt inspiration for your projects.",
  "url": "https://thebulkimagegenerator.com/gallery",
  "numberOfItems": "10000+",
  "keywords": ["AI art", "FLUX images", "AI generated images", "prompt inspiration", "AI image examples"],
  "publisher": {
    "@type": "Organization",
    "name": "The Bulk Image Generator",
    "url": "https://thebulkimagegenerator.com"
  }
};

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <SEO
        title="AI Generated Image Gallery | 10,000+ Examples & Prompt Inspiration"
        description="Browse 10,000+ stunning AI-generated images created with FLUX AI. Get prompt inspiration for your projects from our curated gallery of AI artwork, product photos, and creative visuals."
        keywords="ai image gallery, ai generated images, flux images, ai art examples, image generation showcase, ai prompt inspiration, flux ai examples"
        url="/gallery"
        jsonLd={[
          imageGallerySchema,
          createBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: 'Gallery', url: '/gallery' }
          ])
        ]}
      />
      <Header />
      <main className="pt-20">
        <PublicGallery />
      </main>
      <Footer />
    </div>
  );
};

export default Gallery;
